import React from 'react'

const SvgIconBucketlistHeartOn = (props) => (
  <svg viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      d="M29.6 6c-1.6-1.7-3.8-2.6-6.1-2.6-3.4 0-5.5 1.9-6.7 3.5-.3.4-.6.8-.8 1.2-.2-.4-.5-.8-.8-1.2-1.2-1.6-3.3-3.5-6.7-3.5-2.4 0-4.5.9-6.1 2.6C.9 7.6.1 9.8.1 12.1c0 2.5 1 4.9 3.3 7.4 2 2.3 4.8 4.6 8.2 7.3 1.2 1 2.5 2 3.9 3.2.2.1.4.2.6.2.2 0 .4-.1.6-.2 1.4-1.1 2.6-2.2 3.9-3.2 3.3-2.7 6.2-5 8.2-7.3 2.2-2.5 3.3-4.9 3.3-7.4-.2-2.3-1-4.5-2.5-6.1z"
    />
  </svg>
)

export default SvgIconBucketlistHeartOn
